import { PureComponent } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import promoValidate from './promoValidation'
import * as ContentActions from '../../../../actions/content'
import { ContentTypes } from '../../../../constants'
import { promoForm as promoFormProps } from '../../../../types'
import { ObjectUtils, FileUtils } from '../../../../utils'
import FormWrapper from '../../../../components/Screens/Content/Forms/Promo/FormWrapper'
import { Modal, Form, Column, Button } from '../../../../components'

const { FormGroup, FormHeader } = Form

// Default start date
const defaultStartDateDate = new Date()
defaultStartDateDate.setHours(0)
defaultStartDateDate.setMinutes(0)
defaultStartDateDate.setSeconds(0)
const defaultStartDate = defaultStartDateDate.getTime()

// Default end date
const defaultEndDateDate = new Date()
defaultEndDateDate.setDate(new Date().getDate())
defaultEndDateDate.setHours(24)
defaultEndDateDate.setMinutes(0)
defaultEndDateDate.setSeconds(0)
const defaultEndDate = defaultEndDateDate.getTime() + 1000 * 60 * 60 * 24 * 30

class Promo extends PureComponent {
    static propTypes = {
        promoForm: PropTypes.shape(promoFormProps).isRequired,
        editFormValue: PropTypes.func.isRequired,
        isOpen: PropTypes.bool,
        onClickCancel: PropTypes.func,
        onFinishSubmit: PropTypes.func,
        resetUpload: PropTypes.func.isRequired,
        uploadMedia: PropTypes.func.isRequired,
        media: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        values: PropTypes.shape(promoFormProps),
        channels: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        fetchMedia: PropTypes.func.isRequired,
        reloadPromoInChannel: PropTypes.func.isRequired,
        t: PropTypes.func.isRequired,
    }

    static defaultProps = {
        isOpen: false,
        onClickCancel: () => null,
        onFinishSubmit: () => null,
    }

    constructor(props) {
        super(props)

        this.state = {
            promoId: 0,
            promoFormErrors: {
                name: null,
                file: null,
                date_start: null,
                date_end: null,
            },
            progress: 0,
        }

        this.onChangeFormFile = this.onChangeFormFile.bind(this)
        this.onChangePromoFormValue = this.onChangePromoFormValue.bind(this)
        this.onClickNullStartDate = this.onClickNullStartDate.bind(this)
        this.onClickNullEndDate = this.onClickNullEndDate.bind(this)
        this.onClickRemoveStartDate = this.onClickRemoveStartDate.bind(this)
        this.onClickRemoveEndDate = this.onClickRemoveEndDate.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        const { resetUpload } = this.props
        resetUpload(ContentTypes.MEDIA)
        this.setState({ progress: 0 })
    }

    onChangeFormFile({ target: { name, files } }) {
        const { editFormValue, promoForm } = this.props
        editFormValue('promo', { name, value: files })

        const { name: formFileName } = promoForm

        if (!formFileName && files.length) {
            const { name: fileName } = files[0]
            const fileWithoutExtension = FileUtils.getFileWithoutExtension(fileName)
            editFormValue('promo', { name: 'name', value: fileWithoutExtension })
        }
    }

    onClickNullStartDate() {
        this.onChangePromoFormValue({
            target: { name: 'date_start', value: defaultStartDate },
        })
    }

    onClickNullEndDate() {
        this.onChangePromoFormValue({
            target: { name: 'date_end', value: defaultEndDate },
        })
    }

    onClickRemoveStartDate() {
        this.onChangePromoFormValue({
            target: { name: 'date_start', value: null },
        })
    }

    onClickRemoveEndDate() {
        this.onChangePromoFormValue({
            target: { name: 'date_end', value: null },
        })
    }

    onProgress = (progress) => {
        this.setState({ progress })
    }

    onSubmit = async () => {
        if (!this.validate()) {
            return
        }

        this.setState({ isWorking: true })

        try {
            const { form, onFinishSubmit, uploadMedia } = this.props

            const { file } = form

            const { size } = file[0]

            const media = { ...form, size }

            const { clearUploadProgress, saveUploadProgress } = this.props

            const saved = await uploadMedia(file[0], media, {
                onProgress: ({ progress }) => {
                    saveUploadProgress(progress, file[0].name)
                    this.setState({ progress })
                },
            })

            clearUploadProgress()

            if (saved) {
                await onFinishSubmit([saved])
            }

            this.loadData()
        } catch (e) {
            console.error(e)
            // TODO: Notify failure
        } finally {
            this.setState({ isWorking: false })
        }
    }

    /**
     * Progress in 100 per cent
     */
    get progress() {
        const { progress } = this.state
        return Math.round(progress * 100)
    }

    onChangePromoFormValue({ target: { name, value } }) {
        const { editFormValue } = this.props
        editFormValue('promo', { name, value })
    }

    buildOnchangeObjectPromos() {
        return {
            file: this.onChangeFormFile,
            selected_media: (value) => this.onChangePromoFormValue({ target: { name: 'selected_media', value } }),
            name: this.onChangePromoFormValue,
            date_start: (value) => this.onChangePromoFormValue({ target: { name: 'date_start', value } }),
            date_end: (value) => this.onChangePromoFormValue({ target: { name: 'date_end', value } }),
            metadata: ({ videoHeight, videoLength, videoWidth }) => {
                this.onChangePromoFormValue({
                    target: { name: 'height', value: videoHeight },
                })
                this.onChangePromoFormValue({
                    target: { name: 'length', value: videoLength },
                })
                this.onChangePromoFormValue({
                    target: { name: 'width', value: videoWidth },
                })
            },
        }
    }

    onSavePromo = async (mediaId) => {
        this.setState({ isWorking: true })

        try {
            const { attachMediaToChannel, fetchChannelWithDevices, channels, reloadPromoInChannel } = this.props
            const selectedChannels = channels.filter((channel) => channel.selected)
            selectedChannels.forEach((channel, index) => {
                setTimeout(async () => {
                    await attachMediaToChannel(channel.id, mediaId)
                    await reloadPromoInChannel(channel.id)
                    await fetchChannelWithDevices(channel.id)
                }, index * 1000)
            })
        } catch (e) {
            console.error(e)
        } finally {
            const { onClickSubmit } = this.props
            onClickSubmit()
            this.setState({ isWorking: false })
        }
    }

    /**
     * Form Validation
     */
    validatePromo() {
        let { promoForm } = this.props
        const formErrors = promoValidate(promoForm)
        this.setState({ formErrors })
        return ObjectUtils.isObjValuesEmpty(formErrors)
    }

    onUploadPromo = async () => {
        if (!this.validatePromo()) {
            return
        }

        this.setState({ isWorking: true })

        try {
            const { promoForm, uploadMedia, attachMediaToChannel, fetchChannelWithDevices, channels, reloadPromoInChannel } = this.props
            const { file } = promoForm
            const { size } = file[0]
            const media = { ...promoForm, size }
            const saved = await uploadMedia(file[0], media, {
                onProgress: ({ progress }) => this.setState({ progress }),
            })

            if (saved) {
                const selectedChannels = channels.filter((channel) => channel.selected)
                selectedChannels.forEach((channel, index) => {
                    setTimeout(async () => {
                        await attachMediaToChannel(channel.id, saved.id)
                        await reloadPromoInChannel(channel.id)
                        await fetchChannelWithDevices(channel.id)
                    }, index * 1000)
                })
            }

            this.loadData()
        } catch (e) {
            console.error(e)
        } finally {
            const { onClickSubmit } = this.props
            onClickSubmit()
            this.setState({ isWorking: false })
        }
    }

    /**
     * Fetches new suggestions for the media input
     * @param {string} name Name written on the input
     */
    onTextChangeMedia = (name) => {
        const { fetchMedia } = this.props
        const { textMedia } = this.state

        if (name !== textMedia) {
            fetchMedia(null, { name })
            this.setState({ textMedia: name })
        }
    }

    render() {
        const { media, promoForm, isOpen, onClickCancel, promoFormErrors, t } = this.props
        const { isWorking } = this.state
        return (
            <Modal isOpen={isOpen} onClose={onClickCancel} scrollable>
                <FormHeader>Manage promo</FormHeader>
                <Form>
                    <FormWrapper
                        errors={promoFormErrors}
                        onChangeForm={this.buildOnchangeObjectPromos()}
                        values={promoForm}
                        media={media}
                        onClickCancel={onClickCancel}
                        onClickSave={this.onSavePromo}
                        onClickUpload={this.onUploadPromo}
                        onClickNullStartDate={this.onClickNullStartDate}
                        onClickNullEndDate={this.onClickNullEndDate}
                        onClickRemoveStartDate={this.onClickRemoveStartDate}
                        onClickRemoveEndDate={this.onClickRemoveEndDate}
                        onTextChangeMedia={this.onTextChangeMedia}
                        t={t}
                    />
                    <FormGroup>
                        <Column right width="100%">
                            <Button theme="secondary" onClick={onClickCancel} size="sm">
                                {t('Close')}
                            </Button>
                            <Button theme={isWorking ? 'loading' : 'forestGreen'} onClick={this.onUploadPromo} size="sm" disabled={isWorking}>
                                {isWorking ? `${this.progress} %` : t('Upload')}
                            </Button>
                        </Column>
                    </FormGroup>
                </Form>
            </Modal>
        )
    }
}

const mapStateToProps = ({
    content: {
        media,
        form: { promo: promoForm },
        channels,
    },
}) => ({
    media,
    promoForm,
    channels,
})

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...ContentActions,
        },
        dispatch
    )

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Promo))
